const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");

class CreditCardModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `credit-card-module ${cssVariableKey}`);

    this.contentHash = {};
    this.typingIndicator = null;

    // this.prevEl = null;
  }

  handle(type, value) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleOnMessage(value) {
    const questionOrCCInput = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];
      question.updateAnswer(value.values, this.clearAfterId.bind(this));
    } else if (!this.contentHash[identifier]) {
      const ccParams = { data: {} };

      if (questionOrCCInput.name && questionOrCCInput.number && questionOrCCInput.cvc) {
        for (let p in questionOrCCInput) {
          ccParams.data[p] = questionOrCCInput[p];
        }

        ccParams.data.text = null;
        ccParams.data.subtext = null;
        ccParams.data.format = "creditcard";

        component = new Block(ccParams);
      } else {
        ccParams.data = questionOrCCInput;
        component = new Block(ccParams);
      }

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    } else {
      component = this.contentHash[identifier][1];
      if (value.values && value.values.error && component._option._element.handleOnError) {
        component._option._element.handleOnError(value.values.error);
      }
    }

    // if (!questionOrCCInput) {
    //   component = new Block({
    //     data: {
    //       text: null,
    //       subtext: null,
    //       format: "creditcard"
    //     }
    //   });
    // } else {
    //   const id = questionOrCCInput.id.split("creditcard/").pop();
    //   const ccParams = {data:{}};
    //   if (questionOrCCInput.id.includes('/answer')) {
    //     const question = this.contentHash[id];
    //     question.updateAnswer(value.values, this.clearAfterId.bind(this));
    //     return null;
    //   }

    //   if (questionOrCCInput.name && questionOrCCInput.number && questionOrCCInput.cvc) {

    //     for(let p in questionOrCCInput){
    //       ccParams.data[p] = questionOrCCInput[p];
    //     }

    //     ccParams.data.text = null;
    //     ccParams.data.subtext = null;
    //     ccParams.data.format = "creditcard";

    //     component = new Block(ccParams);
    //   } else {
    //     ccParams.data = questionOrCCInput;
    //     component = new Block(ccParams);
    //   }

    //   this.contentHash[id] = component;
    // }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
    // AR: why is this needed
    // this.parent &&
    //   this.parent.clearAfterId &&
    //   this.parent.clearAfterId(this.value.id);
  }
  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = CreditCardModule;
